import { z } from 'zod'
import FormWrapper from 'app/frontend/base/components/FormWrapper'
import {
  useNotificationTemplateBlacklists,
  usePageInfo,
} from 'app/frontend/base/config/queries'
import SettingField from 'app/frontend/base/components/form-fields/SettingField'
import { useTranslation } from 'react-i18next'
import NotificationBlacklistTable, {
  EditableBlacklist,
} from './NotificationBlacklistTable'
import { zSetting } from 'app/frontend/base/helpers/forms'
import { useQueryClient } from '@tanstack/react-query'

const formSchema = z.object({
  settings: z.object({
    recruitmentNotificationMethod: zSetting(z.string()),
  }),
  notification_template_blacklists_attributes: z.array(
    z.object({
      id: z.number().optional(),
      team_id: z.number().optional().or(z.null()),
      notification_template_type: z.string().optional().or(z.null()),
      _destroy: z.boolean().optional(),
    }),
  ),
})

const UserSettingsNotificationSection = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const {
    data: { user },
  } = usePageInfo()

  const { data, isPending } = useNotificationTemplateBlacklists()

  if (!user || !data || isPending) return null

  return (
    <FormWrapper<
      wowaudit.User & {
        notification_template_blacklists_attributes: EditableBlacklist[]
      }
    >
      formSchema={formSchema}
      entityType='user'
      entity={{
        ...user,
        notification_template_blacklists_attributes: data.blacklists ?? [],
      }}
      onSave={async (form, data) => {
        const { blacklists } = (await queryClient.fetchQuery({
          queryKey: ['notificationTemplateBlacklists'],
        })) as { blacklists: wowaudit.NotificationTemplateBlacklist[] }

        await queryClient.invalidateQueries({ queryKey: ['pageInfo'] })

        form.reset({
          ...data,
          notification_template_blacklists_attributes: blacklists ?? [],
        })
      }}
    >
      <SettingField name='recruitmentNotificationMethod' />

      <h4 className='mt-10'>{t('notifications.user-settings-title')}</h4>
      <p>{t('notifications.user-settings-introduction')}</p>

      <NotificationBlacklistTable />
    </FormWrapper>
  )
}

export default UserSettingsNotificationSection
